import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/0xfix.png";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function useScrollAnimation(options = {}) {
  const [isVisible, setIsVisible] = useState(false);
  const ref = React.useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: options.threshold || 0.1 }
    );

    const currentRef = ref.current;
    if (currentRef) observer.observe(currentRef);
    return () => {
      if (currentRef) observer.unobserve(currentRef);
    };
  }, [options.threshold]);

  return [ref, isVisible];
}

function AnimatedSection({ children, className = "", delay = 0 }) {
  const [ref, isVisible] = useScrollAnimation();
  
  return (
    <div
      ref={ref}
      className={`scroll-animate ${isVisible ? "animate-in" : ""} ${className}`}
      style={{ animationDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
}

function Home2() {
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePos({
        x: (e.clientX / window.innerWidth - 0.5) * 15,
        y: (e.clientY / window.innerHeight - 0.5) * 15,
      });
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  const responsibilities = [
    {
      icon: "📋",
      title: "Compliance with Protocol Rules",
      desc: "A validator must adhere to the rules set by the blockchain protocol, validating transactions according to established rules.",
    },
    {
      icon: "⚡",
      title: "Availability and Reliability",
      desc: "Maintain network availability by remaining online and ready to validate transactions consistently.",
    },
    {
      icon: "🔒",
      title: "Network Security",
      desc: "Ensure network security by preventing attacks and validating transactions with strong cryptographic methods.",
    },
    {
      icon: "✓",
      title: "Accurate Verification",
      desc: "Verify transactions carefully with deep knowledge of the consensus protocol used.",
    },
    {
      icon: "🤝",
      title: "Consensus Participation",
      desc: "Take an active part in the network consensus process, whether PoS, PoW, or other mechanisms.",
    },
    {
      icon: "🌟",
      title: "Transparency",
      desc: "Provide transparency regarding activities, performance, and reliability to build user trust.",
    },
  ];

  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <AnimatedSection className="about-header">
          <h1 className="about-title">
            LET ME <span>INTRODUCE</span>{" "}
            <span className="gradient-text">0xFix</span>
          </h1>
        </AnimatedSection>

        <Row className="align-items-center">
          <Col lg={7} md={12}>
            <AnimatedSection className="about-content" delay={100}>
              <h2 className="section-subtitle">
                Responsibilities of a Good Validator on a Blockchain
              </h2>
              
              <div className="responsibilities-grid">
                {responsibilities.map((item, index) => (
                  <AnimatedSection key={index} delay={200 + index * 100}>
                    <div className="responsibility-card">
                      <div className="resp-icon">{item.icon}</div>
                      <div className="resp-content">
                        <h4>{item.title}</h4>
                        <p>{item.desc}</p>
                      </div>
                    </div>
                  </AnimatedSection>
                ))}
              </div>
            </AnimatedSection>
          </Col>

          <Col lg={5} md={12} className="about-visual-col">
            <AnimatedSection delay={300} className="avatar-container">
              <div className="avatar-wrapper" style={{
                transform: `translate(${mousePos.x}px, ${mousePos.y}px)`
              }}>
                <Tilt>
                  <div className="avatar-glow"></div>
                  <img src={myImg} alt="avatar" className="avatar-image" />
                </Tilt>
                
                <div className="floating-badge badge-1">
                  <span>🔐</span> Secure
                </div>
                <div className="floating-badge badge-2">
                  <span>⚡</span> Fast
                </div>
                <div className="floating-badge badge-3">
                  <span>🌐</span> Global
                </div>
              </div>
            </AnimatedSection>
          </Col>
        </Row>

        <AnimatedSection delay={400} className="contact-section">
          <h1 className="contact-title">Our Contact</h1>
          <p className="contact-subtitle">
            Feel free to <span>connect</span> with{" "}
            <span className="gradient-text">0xFix</span>
          </p>
          
          <div className="social-links-container">
            <a href="/" target="_blank" rel="noreferrer" className="social-link github">
              <AiFillGithub />
            </a>
            <a href="/" target="_blank" rel="noreferrer" className="social-link twitter">
              <AiOutlineTwitter />
            </a>
            <a href="/" target="_blank" rel="noreferrer" className="social-link linkedin">
              <FaLinkedinIn />
            </a>
            <a href="/" target="_blank" rel="noreferrer" className="social-link instagram">
              <AiFillInstagram />
            </a>
          </div>
        </AnimatedSection>
      </Container>
    </Container>
  );
}

export default Home2;
